<input
    type="text"
    [readonly]="readonly"
    [formControl]="formControl"
/>
